import React from 'react';
import styled from 'styled-components';
// components
import NotFound from 'modules/emergencies/components/ui/icon/notFound';
import DateText from 'modules/emergencies/components/ui/texts/DateText';
import CarriersListTable from './carriersListTable/carriersListTable';
import TicketsListContainer from 'modules/emergencies/components/ui/containers/ticketsListContainer';
import BasicLoader from 'modules/emergencies/components/ui/loaders/basicLoader';

const NoResultsContainer = styled.div`
  display: flex;
  flex-grow: 1;
  padding-top: 60px;
  align-items: center;
  flex-direction: column;
`;

const CarriersList = ({ carriersListData, className }) => {
  const hasCarriers = carriersListData?.carriersData?.[0].length > 0;
  return (
    <TicketsListContainer className={className}>
      {carriersListData.isLoadingCarriers ? (
        <BasicLoader />
      ) : hasCarriers ? (
        <CarriersListTable carriersListData={carriersListData} />
      ) : (
        <NoResultsContainer>
          <NotFound />
          <DateText>No carriers were found</DateText>
        </NoResultsContainer>
      )}
    </TicketsListContainer>
  );
};

export default styled(CarriersList)``;
